/**
 * What's Included Image Viewer
 * @param {object} opts
 */
function whatsIncludedViewer(opts) {
  const config = {
    dom: {
      buttonGroup: 'whats-included__left-content-buttons',
      contentGroup: 'js-whats-included-content',
      button: 'data-slide',
      content: 'content-cell',
      selectedClass: 'selected',
    },
  };

  const c = __.extend(config, opts);

  // global elements
  const $buttonGroup = document.querySelector(`.${c.dom.buttonGroup}`);
  const $contentGroup = document.querySelector(`.${c.dom.contentGroup}`);
  const $buttons = $buttonGroup?.querySelectorAll(`[${c.dom.button}]`) || null;
  const $contents = $contentGroup?.querySelectorAll(`.${c.dom.content}`) || null;

  /**
   * Init
   */
  function init() {
    if (!$buttons?.length || !$contents?.length) return;
    addEvents();

    // Select the first button and image by default
    handleButtonClick(0);
  }

  /**
   * Add Events
   */
  function addEvents() {
    $buttons.forEach(($button, index) => {
      __.addEvent({
        id: $button,
        event: 'click',
        fn: () => handleButtonClick(index),
      });
    });
  }

  /**
   * Handle Button Click
   * @param {number} index
   */
  function handleButtonClick(index) {
    // Hide all content cells and remove selected class from all buttons
    $contents.forEach(($content) => {
      $content.style.display = 'none';
    });
    $buttons.forEach(($button) => {
      $button.classList.remove(c.dom.selectedClass);
    });

    // Display the corresponding content cell and add selected class to the clicked button
    $contents[index].style.display = 'block';
    $buttons[index].classList.add(c.dom.selectedClass);
  }

  return init();
}

export default whatsIncludedViewer;
